import createAxios from "./axiosHttpMarconi";

export const whatsappService = {
  getWhatsappChatById,
};

function getWhatsappChatById(whatsappId) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const franquiciaId =
    user && user.extraData ? user.extraData.franquiciaId : "";
  const urlPath = `/franquicia/${franquiciaId}/whatsapp/${whatsappId}`;
  return axios.get(urlPath);
}
